import React, { useEffect } from 'react';
import { toggleApply } from '../../app/redux/actions/globalModalAction';
import { useAppDispatch, useAppSelector } from '../../app/redux/hooks';
import { Opportunity } from '../../types/content';
import OnBoardingWizard from '../account/onBoarding/OnBoardingWizard';
import { ApplyModal } from './ApplyModal';
import GlobalModal from './GlobalModal';
import { useGlobalModal } from './useGlobalModal';

type Props = {
  location: any;
};

const ModalWrapper = ({ location }: Props) => {
  const { setConfig, disableClose, open } = useGlobalModal();
  const { modalConfig, applyModalStatus, applyOpportunity } = useAppSelector((state) => state.globalModal);

  const dispatch = useAppDispatch();
  const { isSignedIn, user, authLevel } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (applyModalStatus && applyOpportunity != undefined) {
      openApplyModal();
    }
  }, [applyModalStatus]);

  // Apply modal configuration
  const openApplyModal = () => {
    setConfig({
      isOverlay: true,
      type: 'apply',
      minheightContent: 'h-auto',
      minWidthContent: 'w-96',
      fullScreen: false
    });
    open();
    disableClose();
  };

  if (modalConfig) {
    switch (modalConfig.type) {
      case 'dashboard-onboarding':
        return (
          <GlobalModal>
            <OnBoardingWizard firstName={user?.firstName} />
          </GlobalModal>
        );
        break;
      case 'apply':
        return (
          <GlobalModal
            onClose={() => {
              dispatch(toggleApply(false));
            }}
          >
            <ApplyModal opportunity={applyOpportunity as Opportunity} />
          </GlobalModal>
        );
    }
  }

  return null;
};

export default ModalWrapper;
